<template>
    <v-card flat class="ma-5">
        <timeline :setup="setup" />
    </v-card>
</template>

<script>
import Timeline from '@/components/Timeline'

export default {
    name: 'detail-tab-timeline',
    components: {
        Timeline
    },
    data: function () {
        return {
            setup: {
                fromDemand: false,
                isEmployee: true,
                showAdd: false,
                showUpdate: true,
                timeline: {
                    className: 'Client'
                }
            }
        }
    }
}
</script>
